import React, { Component } from 'react'; 
import {
    Grid, TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText,
    Typography, Button, IconButton, InputAdornment, 
} from "@material-ui/core";
import SearchIcon from '@material-ui/icons/Search'; 
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardTimePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import es from "date-fns/locale/es";
import moment from 'moment';
import PropTypes from 'prop-types';
import BuscarPersona from '../../../general/BuscarPersona';
import AppBarModal from '../../../general/AppBarModal';

class BienestarFormAgendar extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            fecha_cita: null,
            hora_i_cita: null,
            hora_f_cita: null,
            modalidad: 'virtual',
            lugar: '',
            participante_id: null,         
            participante_nombre: '',        
            openModalBuscarParticipante: false, 
            errors: {}
        };
    }

    componentDidMount() {
        const prof = this.props.profesionalAsignado;
        if (!prof || !prof.id) return;
        const nombre = `${prof.primer_nombre || ''} ${prof.segundo_nombre || ''} ${prof.primer_apellido || ''} ${prof.segundo_apellido || ''}`
            .replace(/\s+/g, ' ')
            .trim();
        this.setState({ participante_id: prof.id, participante_nombre: nombre });
    }

    handleOpenBuscarParticipante = () => {
        this.setState({ openModalBuscarParticipante: true });
    };

    handleCloseBuscarParticipante = () => {
        this.setState({ openModalBuscarParticipante: false });
    };

    handleParticipanteSeleccionado = (data) => {
        if (data) {
            const nombreCompleto = `${data.primer_nombre} ${data.segundo_nombre || ''} ${data.primer_apellido} ${data.segundo_apellido || ''}`.trim();
            this.setState(prevState => ({
                participante_id: data.id,
                participante_nombre: nombreCompleto,
                openModalBuscarParticipante: false, 
                errors: { ...prevState.errors, participante_id: '' } 
            }));
        } else {
            this.handleCloseBuscarParticipante();
        }
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            [name]: value,
            errors: { ...prevState.errors, [name]: '' }
        }));
    };

    handleDateOrTimeChange = (date, name) => {
        this.setState(prevState => ({
            [name]: date,
            errors: { ...prevState.errors, [name]: '' }
        }));
    };

    handleModalidadChange = (e) => {
        const modalidad = e.target.value;
        this.setState(prevState => ({
            modalidad,
            lugar: modalidad === 'virtual' ? '' : prevState.lugar,
            errors: { ...prevState.errors, modalidad: '', lugar: '' }
        }));
    };

    validateForm = () => {
        const { fecha_cita, hora_i_cita, hora_f_cita, modalidad, lugar, participante_id } = this.state;
        let errors = {};
        let isValid = true;
        const obligatorio = "Este campo es obligatorio";
        if (!participante_id) { errors.participante_id = "Debe seleccionar un Profesional"; isValid = false; }
        if (this.props.soloProfesional) {
            this.setState({ errors });
            return isValid;
        }
        if (!fecha_cita) { errors.fecha_cita = obligatorio; isValid = false; }
        if (!hora_i_cita) { errors.hora_i_cita = obligatorio; isValid = false; }
        if (!hora_f_cita) { errors.hora_f_cita = obligatorio; isValid = false; }
        if (hora_i_cita && hora_f_cita && new Date(hora_f_cita) <= new Date(hora_i_cita)) {
            errors.hora_f_cita = "La hora fin debe ser mayor que la hora inicio";
            isValid = false;
        }
        if (!modalidad) { errors.modalidad = obligatorio; isValid = false; }
        if (modalidad === 'presencial' && !lugar) { errors.lugar = obligatorio; isValid = false; }
        this.setState({ errors });
        return isValid;
    };

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validateForm()) {
            const { fecha_cita, hora_i_cita, hora_f_cita, modalidad, lugar, participante_id } = this.state;
            const { onFinish, soloProfesional } = this.props;
            if (soloProfesional) {
                onFinish({ profesional_asignado: participante_id });
                return;
            }
            const datosCita = {
                profesional_asignado: participante_id,
                fecha: moment(fecha_cita).format("YYYY-MM-DD"),
                hora_inicio: moment(hora_i_cita).format("HH:mm:ss"),
                hora_fin: moment(hora_f_cita).format("HH:mm:ss"),
                modalidad: modalidad,
                lugar: modalidad === 'presencial' ? lugar : null,
            };
            onFinish(datosCita);
        }
    };

    render() {
        const { fecha_cita, hora_i_cita, hora_f_cita, modalidad, lugar, errors, openModalBuscarParticipante, participante_nombre } = this.state;
        const { profesionales = [], forwardedRef, soloProfesional = false } = this.props;
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
                <form ref={forwardedRef} onSubmit={this.handleSubmit}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                required
                                margin="normal"
                                name="participante_nombre"
                                label={soloProfesional ? "Profesional que atendió" : "Profesional Asignado"}
                                placeholder="Buscar persona"
                                value={participante_nombre}
                                InputProps={{
                                    readOnly: true, 
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton onClick={this.handleOpenBuscarParticipante}>
                                                <SearchIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                                error={!!errors.participante_id}
                                helperText={errors.participante_id}
                            />
                        </Grid>
                        {!soloProfesional && <>
                        <Grid item xs={12}>
                            <KeyboardDatePicker
                                required
                                fullWidth
                                margin="normal"
                                label="Fecha de la cita"
                                placeholder="Seleccione la fecha"
                                format="yyyy/MM/dd"
                                name="fecha_cita"
                                value={fecha_cita}
                                onChange={(date) => this.handleDateOrTimeChange(date, "fecha_cita")}
                                error={!!errors.fecha_cita}
                                helperText={errors.fecha_cita}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <KeyboardTimePicker
                                required
                                fullWidth
                                margin="normal"
                                label="Hora de inicio"
                                placeholder="Seleccione la hora de inicio"
                                name="hora_i_cita"
                                value={hora_i_cita}
                                onChange={(time) => this.handleDateOrTimeChange(time, "hora_i_cita")}
                                error={!!errors.hora_i_cita}
                                helperText={errors.hora_i_cita}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <KeyboardTimePicker
                                required
                                fullWidth
                                margin="normal"
                                label="Hora fin"
                                placeholder="Seleccione la hora de fin"
                                name="hora_f_cita"
                                value={hora_f_cita}
                                onChange={(time) => this.handleDateOrTimeChange(time, "hora_f_cita")}
                                error={!!errors.hora_f_cita}
                                helperText={errors.hora_f_cita}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth error={!!errors.modalidad}>
                                <InputLabel id="mod-label">Seleccione modalidad</InputLabel>
                                <Select
                                    labelId="mod-label"
                                    name="modalidad"
                                    value={modalidad}
                                    onChange={this.handleModalidadChange}
                                >
                                    <MenuItem value="virtual">Virtual</MenuItem>
                                    <MenuItem value="presencial">Presencial</MenuItem>
                                </Select>
                                {errors.modalidad && <FormHelperText>{errors.modalidad}</FormHelperText>}
                            </FormControl>
                        </Grid>
                        {modalidad === 'presencial' && (
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    margin="normal"
                                    name="lugar"
                                    label="Lugar de atención"
                                    placeholder="Ejemplo: Oficina 203 / Bloque C"
                                    value={lugar}
                                    onChange={this.handleInputChange}
                                    error={!!errors.lugar}
                                    helperText={errors.lugar}
                                />
                            </Grid>
                        )}
                        {modalidad === 'virtual' && (
                            <Grid item xs={12}>
                                <Typography variant="body2" style={{ color: '#007bff' }}>
                                    * El enlace de la reunión virtual será generado automáticamente.
                                </Typography>
                            </Grid>
                        )}
                        </>}
                    </Grid>
                    <div style={{ display: 'none' }}>
                        <Button type="submit" id="submit-agendar-cita">Agendar Cita</Button>
                    </div>

                </form>

            <Dialog 
                open={openModalBuscarParticipante} 
                onClose={this.handleCloseBuscarParticipante}
                fullWidth={true}
                maxWidth="sm"
                aria-labelledby="bienestar-buscar-persona-title"
            >
                <AppBarModal
                    titulo={"Buscar Persona"}
                    mostrarModal={this.handleCloseBuscarParticipante}
                    titulo_accion=""
                    accion=""
                />    
                <DialogContent style={{ padding: '1' }} className="scroll">
                    <BuscarPersona
                    open={openModalBuscarParticipante} 
                    cerrar={this.handleCloseBuscarParticipante}
                    callback={this.handleParticipanteSeleccionado}
                    />
                </DialogContent>
            </Dialog>

            </MuiPickersUtilsProvider>
        );
    }
}

BienestarFormAgendar.propTypes = {
    onFinish: PropTypes.func.isRequired,
    profesionales: PropTypes.array,
    soloProfesional: PropTypes.bool
};

export default React.forwardRef((props, ref) => (
    <BienestarFormAgendar {...props} forwardedRef={ref} />
));

